import React from "react";
import styles from "./SuccessfulPaymentCard.module.scss";
import { ReactComponent as SuccessIcon } from "../../assets/images/payment-success.svg";

type SuccessfulPaymentCardProps = {
  paymentmethod: string;
};
const SuccessfulPaymentCard = ({
  paymentmethod,
}: SuccessfulPaymentCardProps) => {
  return (
    <div className={styles.successful_payment}>
      <SuccessIcon />
      <h3>Transaction Successful</h3>
      <p>Thank you! Your transaction was completed successfully!</p>
    </div>
  );
};

export default SuccessfulPaymentCard;
